import { css, StyleSheet } from 'aphrodite/no-important';
var styles = function () {
    return StyleSheet.create({
        CLOSE_BUTTON: {
            position: 'absolute',
            top: '1rem',
            right: '1rem',
        },
        CONTAINER: {
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            display: 'flex',
        },
        LOADING: {
            alignSelf: 'center',
        },
    });
};
export var DYNAMIC_DEFAULT = {
    backgroundColor: '#FFF',
    bottom: 0,
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
    left: 0,
    margin: 'auto',
    maxWidth: '100%',
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 2147483601,
};
export var getStyles = function () { return ({
    CLOSE_BUTTON: css(styles().CLOSE_BUTTON),
    LOADING: css(styles().LOADING),
    CONTAINER: css(styles().CONTAINER),
}); };
